import React, { useState, useContext, useMemo } from 'react';
import Slider from 'react-slick';
import { Row } from "react-bootstrap";
import styles from "./SliderCrucigrama.module.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { DataContex } from '../../context/DataContext';

export const SliderCrucigrama = ({ activeCrucigramaId, setActiveCrucigramaId }) => {
  const [isAutoplay, setIsAutoplay] = useState(true);
  const { crucigramas: crucigramasData } = useContext(DataContex);
  
  // Filtrar solo los crucigramas que tienen crosswordData
  const crucigramasConDatos = useMemo(() => {
    return crucigramasData.filter(crucigrama => crucigrama.crosswordData);
  }, [crucigramasData]);

  // Estado local para manejar el estado visual de cada crucigrama
  const getEstado = (crucigrama) => {
    if (crucigrama.id === activeCrucigramaId) return "Jugando";
    return crucigrama.estado;
  };

  // Función para manejar la selección de crucigrama
  const handleCrucigramaClick = (crucigramaId) => {
    setActiveCrucigramaId(crucigramaId);
    setIsAutoplay(false);
  };

  // Configuración del slider
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: Math.min(5, crucigramasConDatos.length),
    slidesToScroll: 1,
    arrows: true,
    initialSlide: 0,
    autoplay: isAutoplay,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: Math.min(3, crucigramasConDatos.length),
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: Math.min(2, crucigramasConDatos.length),
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <Row className={styles.sliderContainer}>
      <Slider {...settings}>
        {crucigramasConDatos.map((crucigrama) => (
          <div key={crucigrama.id} className={styles.crucigramaSlide}>
            <div 
              className={
                `${styles.crucigramaContainer} ${styles.disponible} ` +
                (activeCrucigramaId && activeCrucigramaId === crucigrama.id ? styles.jugando : "")
              }
              onClick={() => handleCrucigramaClick(crucigrama.id)}
            >
              <div className={styles.crucigramaMiniatura}>
                {crucigrama.miniatura.letras.map((fila, i) => (
                  <div key={i} className={styles.crucigramaFila}>
                    {fila.map((letra, j) => (
                      <div key={j} className={styles.crucigramaCelda}>
                        {letra}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
              <div className={styles.crucigramaInfo}>
                <h3>{crucigrama.title}</h3>
                <p>{crucigrama.description}</p>
                <span className={styles.estado}>{getEstado(crucigrama)}</span>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </Row>
  );
};
